export type ProductTemplateLabel = {
  value: string;
  defaultValue: string;
};

export type ProductViewTemplateConfig = {
  version: number;
  sections: {
    price: {
      visible: boolean;
    };
    quantity: {
      visible: boolean;
      label: ProductTemplateLabel;
    };
    actions: {
      buyNow: {
        visible: boolean;
        label: ProductTemplateLabel;
      };
      addToCart: {
        visible: boolean;
        label: ProductTemplateLabel;
      };
    };
    tabs: {
      description: {
        visible: boolean;
        label: ProductTemplateLabel;
      };
      conditions: {
        visible: boolean;
        label: ProductTemplateLabel;
      };
    };
    [key: string]: any;
  };
};

export type ProductViewTemplatePayload = {
  templateName: string;
  isActive: number;
  configJson: ProductViewTemplateConfig;
  translatedContent: any;
};

const label = (value: string): ProductTemplateLabel => ({
  value,
  defaultValue: value,
});

export const DEFAULT_PRODUCT_VIEW_TEMPLATE: ProductViewTemplatePayload = {
  templateName: 'Plantilla de producto',
  isActive: 1,
  configJson: {
    version: 1,
    sections: {
      price: {
        visible: true,
      },
      quantity: {
        visible: true,
        label: label('Cantidad'),
      },
      actions: {
        buyNow: {
          visible: true,
          label: label('Comprar ahora'),
        },
        addToCart: {
          visible: true,
          label: label('Agregar al carrito'),
        },
      },
      tabs: {
        description: {
          visible: true,
          label: label('Detalles'),
        },
        conditions: {
          visible: true,
          label: label('Condiciones'),
        },
      },
    },
  },
  translatedContent: null,
};

export function cloneProductViewTemplate(
  template: ProductViewTemplatePayload = DEFAULT_PRODUCT_VIEW_TEMPLATE
): ProductViewTemplatePayload {
  return JSON.parse(JSON.stringify(template));
}
